import React from 'react';
import { Input, Button } from 'antd';
import { MailOutlined, FacebookOutlined, TwitterOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { FaTiktok, FaWhatsapp } from 'react-icons/fa';
import app  from "../../assets/app.jpg"
import play from "../../assets/play.jpg"

const Footer = () => {
  return (
    <div className="w-full bg-gray-800 text-white py-3 px-2">
      {/* Newsletter Section */}
      <div className="bg-green-800 py-2 px-4">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-white text-sm">
            <div className="flex items-center gap-2">
              <MailOutlined className="text-base" />
              <h3 className="font-medium text-sm">Get Special Offers</h3>
            </div>
            <p className="text-xs">Stay updated on deals & events.</p>
          </div>
          <div className="flex w-full md:w-auto gap-2">
            <Input placeholder="Your email" className="w-full md:w-56 h-8 rounded-sm text-xs" />
            <Button type="primary" className="bg-white text-blue-500 hover:bg-gray-100 h-8 text-xs px-3">
              Subscribe
            </Button>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-4 py-4 px-4">
        {/* Company Info */}
        <div className="md:col-span-1">
          <img src={require('../../assets/frankoIcon.png')} alt="Franko Trading" className="h-14 mb-2" />
          <p className="text-gray-300 text-xs leading-snug">
            Your premier outlet for phones & accessories.
          </p>
          <div className="mt-3">
            <p className="text-xs font-semibold">Have Questions?</p>
            <a href="tel:+233246422338" className="text-white text-sm font-bold">
            +233 246 422 338
            </a>
            <Button
              type="primary"
              size="small"
              className="bg-green-700 mt-2 flex items-center gap-1 px-3 py-1 text-xs"
              onClick={() => window.open('https://wa.me/233246422338', '_blank')}
            >
              <FaWhatsapp className="text-sm text-white" />
              Chat
            </Button>
          </div>
        </div>

        {/* Links */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 text-xs">
          <div>
            <h4 className="font-semibold mb-2">Company</h4>
            <ul className="space-y-1">
              <li><Link to="/about" className="text-gray-300 hover:text-white">About</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-white">Contact</Link></li>
              <li><Link to="/terms" className="text-gray-300 hover:text-white">Terms</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-2">Account</h4>
            <ul className="space-y-1">
              <li><Link to="/profile" className="text-gray-300 hover:text-white">Profile</Link></li>
              <li><Link to="/sign-up" className="text-gray-300 hover:text-white">Sign Up</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-2">Orders</h4>
            <ul className="space-y-1">
              <li><Link to="/order-history" className="text-gray-300 hover:text-white">Order History</Link></li>
            </ul>
          </div>
        </div>

        {/* App Download & QR Code */}
        <div className="mt-4">
  <p className="text-sm text-gray-400 mb-2">
    Download our app for exclusive deals and faster checkout.
  </p>

  <div className="flex flex-wrap gap-2">
    <a
      href="https://apps.apple.com/us/app/franko-trading/id6741319907"
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center bg-white px-2 py-1 rounded-md hover:bg-gray-100 transition"
    >
      <img
        src={app}
        alt="Download on the App Store"
        className="h-8 w-auto object-contain"
      />
    </a>

    <a
      href="https://play.google.com/store/apps/details?id=com.poldark.mrfranky2"
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center bg-white px-2 py-1 rounded-md hover:bg-gray-100 transition"
    >
      <img
        src={play}
        alt="Download on Google Play"
        className="h-8 w-auto object-contain"
      />
    </a>
  </div>
</div>

      </div>

      {/* Bottom Footer */}
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center py-2 px-4 border-t border-gray-700 text-xs">
        <div className="text-gray-400">© 2024 Franko Trading Ltd.</div>
        <div className="flex gap-3 mt-2 md:mt-0">
          <a href="https://www.facebook.com/frankotradingenterprise" target="_blank" rel="noopener noreferrer">
            <FacebookOutlined className="text-sm hover:text-blue-400" />
          </a>
          <a href="https://x.com/frankotrading1" target="_blank" rel="noopener noreferrer">
            <TwitterOutlined className="text-sm hover:text-blue-400" />
          </a>
          <a href="https://www.tiktok.com/@frankotrading" target="_blank" rel="noopener noreferrer">
            <FaTiktok className="text-sm hover:text-blue-400" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
